import { includes, some, map, sum, get, round, filter, isEmpty, every, flatMap, compact } from 'lodash'
import axios from 'lib/axios'

const filteredCustomers = ({ customers, filters }) => filter(compact(customers), (customer) => {
  const filterResults = {}

  if (filters.locations != 'All') {
    const locationIds = map(filters.locations, 'value')

    filterResults['locations'] = some(flatMap(customer.cluster_functions, 'vms'), vm => includes(locationIds, get(vm, 'location_id')))
  }

  if (filters.functions != 'All') {
    const functionIds = map(filters.functions, 'value')

    filterResults['functions'] = some(customer.cluster_functions, clusterFunction => includes(functionIds, clusterFunction.function))
  }

  if (filters.clusters != 'All') {
    const clusterIds = map(filters.clusters, 'value')

    filterResults['clusters'] = some(customer.cluster_functions, clusterFunction => includes(clusterIds, clusterFunction.id))
  }

  if (filters.ownership != 'All') {
    const ownership = map(filters.ownership, 'value')

    filterResults['ownership'] = some(customer.cluster_functions, clusterFunction => includes(ownership, clusterFunction.ownership))
  }

  if (filters.powerState != 'All') {
    filterResults['powerState'] = some(flatMap(customer.cluster_functions, 'vms'), vm => vm.power_state.replace('Powered', '') === filters.powerState)
  }

  if (filters.billable != 'All') {
    filterResults['billable'] = some(flatMap(customer.cluster_functions, 'vms'), vm => vm.billable === filters.billable)
  }

  if (filters.customers != 'All') {
    filterResults['customers'] = includes(map(filters.customers, 'value'), get(customer, 'customer_id'))
  }

  if (filters.customerStatus != 'All') {
    filterResults['customerStatus'] = includes(map(filters.customerStatus, 'value'), get(customer, 'customer_status'))
  }

  if (filters.assetTypes != 'All') {
    filterResults['assetTypes'] = some(flatMap(customer.cluster_functions, 'vms'), vm => includes(map(filters.assetTypes, 'value'), vm.asset_label))
  }

  const hasMatchedFilters = every(filterResults, (value, _key) => value === true)

  return (hasMatchedFilters || isEmpty(filterResults))
})

const filteredClusterFunctions = (clusterFunctions = [], filters) => filter(compact(clusterFunctions), (clusterFunction) => {
  const filterResults = {}

  if (filters.clusters != 'All') {
    const clusterIds = map(filters.clusters, 'value')

    filterResults['clusters'] = includes(clusterIds, clusterFunction.id)
  }

  if (filters.ownership != 'All') {
    const ownershipIds = map(filters.ownership, 'value')

    filterResults['ownership'] = includes(ownershipIds, clusterFunction.ownership)
  }

  if (filters.powerState != 'All') {
    filterResults['powerState'] = some(clusterFunction.vms, vm => vm.power_state.replace('Powered', '') === filters.powerState)
  }

  if (filters.billable != 'All') {
    filterResults['billable'] = some(clusterFunction.vms, vm => vm.billable === filters.billable)
  }

  if (filters.functions != 'All') {
    const functionIds = map(filters.functions, 'value')

    filterResults['functions'] = includes(functionIds, clusterFunction.function)
  }

  if (filters.assetTypes != 'All') {
    filterResults['assetTypes'] = some(clusterFunction.vms, vm => includes(map(filters.assetTypes, 'value'), vm.asset_label))
  }

  if (filters.locations != 'All') {
    const locationIds = map(filters.locations, 'value')

    filterResults['locations'] = some(clusterFunction.vms, vm => includes(locationIds, get(vm, 'location_id')))
  }

  return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
})


const filteredVMs = (vms = [], filters) => filter(compact(vms), (vm) => {
  const filterResults = {}

  if (filters.powerState != 'All') {
    filterResults['powerState'] = vm.power_state.replace('Powered', '') === filters.powerState
  }

  if (filters.locations != 'All') {
    const locationIds = map(filters.locations, 'value')

    filterResults['locations'] = includes(locationIds, get(vm, 'location_id'))
  }

  if (filters.functions != 'All') {
    const functionIds = map(filters.functions, 'value')

    filterResults['functions'] = includes(functionIds, vm.cluster_function)
  }

  if (filters.clusters != 'All') {
    const clusterIds = map(filters.clusters, 'value')
    filterResults['clusters'] = includes(clusterIds, vm.cluster_id)
  }

  if (filters.ownership != 'All') {
    const ownership = map(filters.ownership, 'value')
    filterResults['ownership'] = includes(ownership, vm.cluster_ownership)
  }

  if (filters.managedByCalligo != 'All') {
    filterResults['managedByCalligo'] = vm.managed_by_calligo === filters.managedByCalligo
  }

  if (filters.billable != 'All') {
    filterResults['billable'] = vm.billable === filters.billable
  }

  if (filters.assetTypes != 'All') {
    filterResults['assetTypes'] = includes(map(filters.assetTypes, 'value'), vm.asset_label)
  }

  return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
})

const sumVMData = (vms, filters, field) => round(
  sum(map(
    filteredVMs(vms, filters),
    vm => parseFloat(vm[field])
  ))
)

const sendVMsToUpdate = (event, vmsToUpdate, setFlashMessage) => {
  event.preventDefault()
  const patchData = { vms: map(vmsToUpdate, ({ id, billable }) => ({ id, billable })) }
  setFlashMessage(null) // Wipe alert so users can see a change

  axios.patch('/assets/cloudcore/billing', patchData)
    .then((response) => setFlashMessage({ variant: 'success', message: response.data.message }))
    .catch((e) => setFlashMessage({ variant: 'error', message: get(e, 'data.message', e.message) }))
}

export { filteredCustomers, filteredClusterFunctions, filteredVMs, sumVMData, sendVMsToUpdate }
